export enum SortPostListTypes {
  newest = 'newest',
  oldest = 'oldest',
  descPrice = 'descPrice',
  ascPrice = 'ascPrice',
}

export const DEFAULT_SORT_TYPE = SortPostListTypes.newest
